module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/entrepreneurship-is-still-a-boys-club.json
// module id = 1341
// module chunks = 108399679768186